export const isSecretTriaged = (policy, exposed) => {
    const triagedPolicyIds = ["SQ34101", "SQ34251", "SQ34301"];
    return ((triagedPolicyIds.includes(policy.id) && policy.status === "pass") ||
        !exposed);
};
//# sourceMappingURL=secrets.js.map